/**
 * Anonymize Email API wrapper
 *
 * POST /api/v1/admin-anonymize-email - Anonymize all records for a given email
 */

import { api } from "../common/utils"
import { ANONYMIZE_EMAIL_ENDPOINT } from "../common/constants"

export interface AnonymizeEmailPayload {
  email: string
}

export interface AnonymizeEmailResponse {
  status: string
  message: string
  leads_anonymized: number
  subscriptions_anonymized: number
  pending_subscriptions_anonymized: number
}

const anonymizeEmail = {
  anonymize: async (
    payload: AnonymizeEmailPayload
  ): Promise<AnonymizeEmailResponse> => {
    if (!payload.email) {
      throw new Error("email is required")
    }

    const { data } = await api.post(ANONYMIZE_EMAIL_ENDPOINT, payload)
    return data
  }
}

export default anonymizeEmail
